import axios from "axios";

export type GuidanceSource = {
  id: string;
  name: string;
  url: string;
  description: string;
  logoUrl: string;
  country: {
    name: string;
    code: string;
    flagUrl: string;
  };
};

export async function getGuidanceSources(): Promise<GuidanceSource[]> {
  const { data } = await axios.get("/guidance/sources");
  return data;
}
